export default __webpack_public_path__ + "static/media/info-main-sm.b003c38c.jpg";